import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {map} from "rxjs/operators";

@Injectable()
export class UserSwitchService {
  private url: string = "/api/users";

  constructor(private http: HttpClient) {}

  resumeUser(): Promise<string> {
    return this.http.post(`${this.url}/restore-user`, {})
      .pipe(map(obj => `${obj["id"]}`))
      .toPromise();
  }
}
